<template>
  <div style="margin-left: 0px;">
    <div v-if="debug_show_page_name==true" style="color:green;">sub-table-temp-certificate-information</div>
    <div :class="'container ' + pageContainerSize">
      <ag-grid-vue style="width: 100%; height: 530px" class="ag-blue" :gridOptions="gridOptions"></ag-grid-vue>
                <br>
             件数<input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_certificate_information";
import { utils } from "@/libs/utils";

import _debug from "debug";
var mdebug = _debug("esma:master_user");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "ag-grid-vue": AgGridVue
  },
  data() {
    return {
      api_name: "temp_certificate_information",
      page_acl: acl.generic,
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    values() {
      console.log("values");
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.certificate_management_number, {}),
        utils.extend(fields.license_jurisdiction_team, {}),
        utils.extend(fields.jurisdiction_classification, {}),
        utils.extend(fields.license_jurisdiction_system, {}),
        utils.extend(fields.licensed_department, {}),
        utils.extend(fields.maker, {}),
      ];
    }
  },
  methods: {
    onDetailsClick(ev, data) {
      console.log("onDetailsClick", data);
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: data.seq_id }
      });
    },
    createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(f => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        if(f.id == "maker" ){
          // fi.cellRenderer = (params) =>{

          //     console.log("params",params," DATA", params.data)
          //     if(params.data && params.value != params.data.maker_name){
          //       return "<span style='color:red;background:orange'>-" + params.value + "</span>";
          //     }else{
          //       return params.value ;
          //     }
          // }
          fi.cellStyle =(params) =>{
            var val = _.get(params,"value"," ") || "";
            var maker_name = _.get(params,"data.maker_name","-") || "";

            if(params.data && val.toLowerCase() != maker_name.toLowerCase()){
              return {fontWeight: 'bold', backgroundColor: 'orange'};
            }
            if(params.value == ""){
              return {fontWeight: 'bold', backgroundColor: '#d2962a'};
            }
            return null;
          }
        }
        arr.push(fi);
      });
      return arr;
    },
    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {},
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource();
  }
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// sub-table-temp-certificate-information.vue?23664f82